var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 30.63 2.73 36.6 7.08 40.92L0 48H18V30L11.28 36.72C8.04 33.45 6 28.98 6 24C6 16.17 11.01 9.51 18 7.05V0.780001C7.65 3.45 0 12.81 0 24ZM24 39H30V33H24V39ZM54 0H36V18L42.72 11.28C45.96 14.55 48 19.02 48 24C48 31.83 42.99 38.49 36 40.95V47.22C46.35 44.55 54 35.19 54 24C54 17.37 51.27 11.4 46.92 7.08L54 0ZM24 27H30V9H24V27Z",
    fill: "#C61944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.fae619ba476b16a1f021b2ed58791ddf.svg";
export { ForwardRef as ReactComponent };